// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import DialogPolyfill from "dialog-polyfill";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import DialogModuleCss from "./Dialog.module.css";
import * as Webapi__Dom__HtmlElement from "rescript-webapi/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.jsx";

let classes = DialogModuleCss;

function Dialog(props) {
  let visible = props.visible;
  let onClickOutside = props.onClickOutside;
  let match = React.useState(() => {});
  let setDialogNode = match[1];
  let maybeDialogNode = match[0];
  let visibilityDeps = [
    maybeDialogNode,
    visible
  ];
  React.useEffect(() => {
    if (maybeDialogNode !== undefined) {
      let dialog = Primitive_option.valFromOption(maybeDialogNode);
      if (visible) {
        dialog.showModal();
      } else {
        dialog.close();
      }
    }
  }, visibilityDeps);
  let onClickOutsideRef = React.useRef(onClickOutside);
  onClickOutsideRef.current = onClickOutside;
  let lightDismissibleDeps_1 = onClickOutside !== undefined;
  let lightDismissibleDeps = [
    maybeDialogNode,
    lightDismissibleDeps_1
  ];
  React.useEffect(() => {
    if (maybeDialogNode === undefined) {
      return;
    }
    if (!lightDismissibleDeps_1) {
      return;
    }
    let dialogElement = Webapi__Dom__HtmlElement.ofElement(Primitive_option.valFromOption(maybeDialogNode));
    if (dialogElement === undefined) {
      return;
    }
    let dialogElement$1 = Primitive_option.valFromOption(dialogElement);
    let handler = event => {
      let targetIsDialog = event.target.nodeName === "DIALOG";
      let match = onClickOutsideRef.current;
      if (targetIsDialog && match !== undefined) {
        return match();
      }
    };
    dialogElement$1.addEventListener("click", handler);
    return () => {
      dialogElement$1.removeEventListener("click", handler);
    };
  }, lightDismissibleDeps);
  return <dialog
    ref={Primitive_option.some(node => {
      setDialogNode(param => {
        if (!(node == null)) {
          DialogPolyfill.registerDialog(node);
          return Primitive_option.some(node);
        }
      });
    })}
    className={classes.root + ` ` + Stdlib_Option.getOr(props.className, "")}
  >
    {props.children}
  </dialog>;
}

function Dialog$DialogBody(props) {
  return <div
    className={classes.scrollContent}
  >
    {props.children}
  </div>;
}

let DialogBody = {
  make: Dialog$DialogBody
};

let make = Dialog;

export {
  classes,
  make,
  DialogBody,
}
/* classes Not a pure module */
